import { render } from "./CpBreadcrumb.vue?vue&type=template&id=1441f840"
import script from "./CpBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CpBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__